import { z } from 'zod'
import { updateInvoiceChargesSchema } from '@/features/invoices/schemas'
import { validateResponseIsOk } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'

const client = createAssetManagementClient()

export const updateInvoiceCharges = (invoiceId: number, charges: z.infer<typeof updateInvoiceChargesSchema>) =>
  validateResponseIsOk(
    client.sendPatch(
      `billing/invoices/${invoiceId}/charges`,
      { data: updateInvoiceChargesSchema.parse(charges) }
    )
  ).then(
    () => { }
  )
